import { Component, OnInit } from '@angular/core';
import { ContactService } from '../../_services/contact.service';
import { CompanyService } from '../../_services/company.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
declare var jQuery: any;
import '../../../assets/semantic/semantic.min.js';

import { SecurityService } from '../../_services/security.service';
@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {
  // page param (stored in URL)
  private page_param: string;
  private is_admin: number = 0;
  // for table
  private companies: object[];
  private companies_count: number;
  private page_number: number;
  private page_count: number;
  private page_indicators: number[];
  private contacts: object[];


  constructor(private auth: SecurityService, private service: CompanyService, private contact_service: ContactService, private route: ActivatedRoute, private router: Router) { }

  filters = new FormGroup({
    email: new FormControl(''),
    name: new FormControl(''),
    phone: new FormControl('')
  });

  ngOnInit() {

    // Get the Params..
    this.route.queryParams.subscribe(params => {
      this.page_param = params['page'] || 1; // Get Page number Param
    });

    this.filters.valueChanges.debounceTime(500).subscribe(
      (value) => {
        this.router.navigate(['/companies'], { queryParams: { page: '1' } })
        this.refresh();
      }
    )

    this.refresh();
    jQuery('.rating').first().rating();
  }
  
  toggleFavorite(company: any) {
    company.is_favorite = !company.is_favorite; // Inverse le statut de favori

    // Appel au service pour mettre à jour le statut de favori dans la base de données
    this.service.updateFavoriteStatus(company.id, company.is_favorite).subscribe(response => {
      // Gérer la réponse si nécessaire
      console.log('Statut de favori mis à jour', response);
    }, error => {
      // Gérer les erreurs si nécessaire
      console.error('Erreur lors de la mise à jour du statut de favori', error);
    });
  }
  refresh() {
    let params = {};
    Object.assign(params, this.filters.value, { page: this.page_param });
    this.service.getCompanies(params) // Get Companies List
      .subscribe(response => {
        //secure ??
        this.is_admin = response.is_admin;
        this.companies = response.companies;                      // Contact Page List
        this.companies_count = parseInt(response.total_count);   // Contact Count
        this.page_number = parseInt(response.page);              // Current Page
        this.page_count = Math.ceil(this.companies_count / 25);   // Page Count
        // Page Indicators (for ngFor iterations)
        if (this.page_count < 10) {
          this.page_indicators = Array(this.page_count).fill(1);
        } else {
          this.page_indicators = Array(10).fill(1);
        }
      });
  }

  // Previous Page Button
  previousPage() {
    this.router.navigate(['/companies'], { queryParams: { page: this.page_number - 1 } }).then(function () {
      this.refresh();
    }.bind(this));
  }

  // Next Page Button
  nextPage() {
    this.router.navigate(['/companies'], { queryParams: { page: this.page_number + 1 } }).then(function () {
      this.refresh();
    }.bind(this));
  }

  // Go to page n°nb
  toPage(nb: number) {
    this.router.navigate(['/companies'], { queryParams: { page: nb } }).then(function () {
      this.refresh();
    }.bind(this));
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/company/company.component.ts